import React from 'react'
import styled from '@emotion/styled'
import { measurements } from '@mobi/component-library/Foundations'
import { startListening } from '@core/Store/listenerMiddleware'
import { KAMBI_CSS_HIDDEN_CLASS, KAMBI_CLIENT_DIV_ID } from '@core/Areas/KambiClient/constants'
import { setKambiClientVisibility } from '@core/Areas/KambiClient/Store'

/** Main component to render Kambi client - NOT within react-router routes */
export const KambiClient: React.FC = React.memo(() => {
  const kambiClientElRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!kambiClientElRef.current) return undefined
    const clientEl = kambiClientElRef.current

    const dispose = startListening({
      actionCreator: setKambiClientVisibility,
      effect: action => (!action.payload ? clientEl.removeAttribute('style') : undefined),
    })
    return () => dispose()
  }, [])

  return (
    <WrapperStyled className='mobi__z-stack-bottom mobi__unset-globals'>
      <div
        ref={kambiClientElRef}
        id={KAMBI_CLIENT_DIV_ID}
        className={KAMBI_CSS_HIDDEN_CLASS}
        key='kambi-client'
      />
    </WrapperStyled>
  )
})

KambiClient.displayName = 'KambiClient'

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  maxWidth: `${measurements.mobi.maxWidth} !important`,
  margin: 'auto !important',
})
